import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space, btnSecondary } from '../styles/theme.js'
import { authModel } from '../models/auth.js'

const MOBILE = '(max-width: 768px)'

const navStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space.md} ${space.xl};
  background: ${colors.bgCard};
  border-bottom: 1px solid ${colors.border};
  @media ${MOBILE} {
    padding: ${space.sm} ${space.md};
  }
`

const logoStyle = css`
  font-size: ${font.size['2xl']};
  font-weight: ${font.weight.bold};
  color: ${colors.brand};
  text-decoration: none;
  letter-spacing: -0.5px;
  &:hover { text-decoration: none; }
`

const navLinks = css`
  display: flex;
  align-items: center;
  gap: ${space.md};
`

const navLink = css`
  font-size: ${font.size.sm};
  color: ${colors.textSecondary};
  text-decoration: none;
  &:hover {
    color: ${colors.text};
    text-decoration: none;
  }
`

const mainStyle = css`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${space.xl};
  @media ${MOBILE} {
    padding: ${space.sm} ${space.md};
  }
`

function Nav() {
  return {
    view() {
      return m('nav', { class: navStyle }, [
        m(m.route.Link, { href: '/projects', class: logoStyle }, 'HYPO'),
        authModel.isLoggedIn
          ? m('div', { class: navLinks }, [
              m(m.route.Link, { href: '/projects', class: navLink }, 'Projects'),
              m('span', { class: css`font-size: ${font.size.sm}; color: ${colors.textMuted};` },
                authModel.user?.name),
              m('button', {
                class: btnSecondary,
                onclick: () => authModel.logout(),
              }, 'Log out'),
            ])
          : null,
      ])
    },
  }
}

export function Layout() {
  return {
    view(vnode) {
      return m('div', [
        m(Nav),
        m('main', { class: mainStyle }, vnode.children),
      ])
    },
  }
}
